<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-09 15:14:30
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <div>
        <div class="adddBtnBox">
          <el-button type="primary" @click="addPopShow=true">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :border="true" height="700" stripe>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="nickName" label="昵称"></el-table-column>
          <el-table-column prop="userName" label="用户名"></el-table-column>
          <el-table-column prop="areaCode" label="区域编码"></el-table-column>
          <el-table-column prop="country" label="区域名"></el-table-column>
          <el-table-column prop="email" label="邮箱"></el-table-column>
          <el-table-column prop="tel" label="电话"></el-table-column>

          <el-table-column prop="address" label="操作" width="250">
            <template slot-scope="scope">
              <el-button size="mini" @click="editMsg(scope.row)">修改</el-button>
              <el-popconfirm title="这是一段内容确定删除吗？" @confirm="mydelete(scope.row.id)">
                <el-button size="mini" type="danger" slot="reference">移除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination background layout="prev, pager, next" :total="1"></el-pagination> -->
    </el-card>
    <el-dialog title="信息新增" :visible.sync="addPopShow" width="30%">
      <div class="inpTbox">
        <div>区域</div>
        <div>
          <el-select v-model="addData.areaCode" placeholder="请选择" size="mini">
            <el-option :label="item.areaName" :value="item.areaCode" v-for="item in areaListData"></el-option>
          </el-select>
        </div>
      </div>

      <el-input placeholder="请输入内容" v-model="addData.country" style="margin-top:10px">
        <template slot="prepend">区域</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.userName" style="margin-top:10px">
        <template slot="prepend">用户名</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.passWord" style="margin-top:10px">
        <template slot="prepend">密码</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.nickName" style="margin-top:10px">
        <template slot="prepend">昵称</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.tel" style="margin-top:10px">
        <template slot="prepend">电话</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.eMail" style="margin-top:10px">
        <template slot="prepend">邮箱</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addPopShow = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="信息修改" :visible.sync="editPopShow" width="30%">
      <div class="inpTbox">
        <div>区域</div>
        <div>
          <el-select v-model="editData.areaCode" placeholder="请选择" size="mini">
            <el-option :label="item.areaName" :value="item.areaCode" v-for="item in areaListData"></el-option>
          </el-select>
        </div>
      </div>

      <el-input placeholder="请输入内容" v-model="editData.country" style="margin-top:10px">
        <template slot="prepend">区域</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.userName" style="margin-top:10px">
        <template slot="prepend">用户名</template>
      </el-input>

      <el-input placeholder="请输入内容" v-model="editData.nickName" style="margin-top:10px">
        <template slot="prepend">昵称</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.tel" style="margin-top:10px">
        <template slot="prepend">电话</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.eMail" style="margin-top:10px">
        <template slot="prepend">邮箱</template>
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editPopShow = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      areaListData: [],
      textarea: "",
      input1: "",
      tableData: [],
      value: "0",
      allData: [],
      dialogVisible: false,
      chooseData: {},
      addPopShow: false,
      editPopShow: false,
      addData: {
        userName: "",
        passWord: "",
        country: "",
        tel: "",
        eMail: "",
        areaCode: "",
        nickName: ""
      },
      editData: {
        userName: "",
        passWord: "",
        country: "",
        tel: "",
        eMail: "",
        areaCode: "",
        nickName: ""
      }
    };
  },
  created() {
    this.getAreaList();
    this.getTableData();
  },
  methods: {
    getAreaList() {
      this.axios({
        method: "get",
        url:
          "http://120.79.183.250:3093/InterfaceServices/AreaService/queryAreaList",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        // console.log(res.data);
        this.areaListData = res.data.data;
        // this.tableData = res.data;
      });
    },
    mydelete(data) {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/user/delete",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          id: data
        }
      }).then(res => {
        // console.log(res.data);
        // this.tableData = res.data;
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.addPopShow = false;
        this.getTableData();
      });
    },
    editMsg(data) {
      console.log(data);
      //   this.editData = data;
      this.editData.userName = data.userName;
      this.editData.passWord = data.passWord;
      this.editData.country = data.country;
      this.editData.tel = data.tel;
      this.editData.eMail = data.email;
      this.editData.nickName = data.nickName;
      this.editData.areaCode = data.areaCode;
      this.editData.id = data.id;
      this.editPopShow = true;
    },
    submitEdit() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/user/modify",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: this.editData
      }).then(res => {
        console.log(res.data);
        this.editPopShow = false;
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.getTableData();
        // this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    },
    submitAdd() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/user/add",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: this.addData
      }).then(res => {
        console.log(res.data);
        this.addPopShow = false;
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.getTableData();
        // this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    },
    sendMsg(data) {
      console.log(data);
      this.chooseData = data;
      this.dialogVisible = true;
    },
    TypeChange() {
      //   this.tableData = this.allData[this.value];
    },
    getTableData() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/user/getUsers",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          userName: "null",
          country: "null",
          tel: "null",
          eMail: "null",
          areaCode: "null",
          nickName: "null"
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    }
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
.inpTbox {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
</style>